import React, { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import * as apis from 'apis';
import BlogDetail from 'components/views/BlogDetail/BlogDetail';
import { Header, Footer } from 'components/views';

export default function BlogDetailContainer() {
  const { id } = useParams(); // URL parameter: /blog/:id (여기서는 slug 역할)
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  // slug(제목)으로 ID를 찾는 로직
  // 주의: 제목이 중복되거나 변경되면 찾을 수 없을 수 있음
  const findIdBySlug = async (slug) => {
    try {
      // 슬러그에서 원래 제목 유추 (대략적인 검색)
      // slug는 "제목-형태" 처럼 되어있으므로 "-"를 공백으로 바꿔서 검색 시도
      const searchTerm = slug.replace(/-/g, ' ');

      // 검색 API 호출
      const res = await apis.getBlogList(0, 20, searchTerm);
      const list = res.data.data;

      // 리스트에서 제목이 (Slug 규칙을 적용했을 때) 일치하는 항목 찾기
      const found = list.find((item) => {
        const itemSlug = item.title
          .trim()
          .replace(/[^a-zA-Z0-9\u3131-\u3163\uac00-\ud7a3\s]/g, '')
          .replace(/\s+/g, '-');
        return itemSlug === slug;
      });

      return found ? found.id : null;
    } catch (error) {
      console.error('Error finding blog ID by slug:', error);
      return null;
    }
  };

  useEffect(() => {
    const fetchDetail = async () => {
      if (!id) return;

      setLoading(true);
      try {
        let blogId = null;

        // 1. 숫자로만 구성되어 있으면 ID로 간주 (기존 호환성)
        if (/^\d+$/.test(id)) {
          blogId = parseInt(id, 10);
        }
        // 2. 숫자로 시작하고 '-'가 있으면 "ID-제목" 형태일 가능성 (이전 방식 호환성)
        else if (/^\d+-/.test(id)) {
          blogId = parseInt(id, 10);
        }
        // 3. 그 외에는 제목(Slug)으로 간주 -> 검색해서 ID 찾기
        else {
          blogId = await findIdBySlug(id);
        }

        if (blogId) {
          const res = await apis.getBlogDetail(blogId);
          setData(res.data);
        } else {
          console.error('Cannot find blog ID for slug:', id);
          setData(null);
        }
      } catch (error) {
        console.error('Failed to fetch blog detail:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchDetail();
  }, [id]);

  const handleGoList = useCallback(() => {
    navigate('/blog');
  }, [navigate]);

  if (loading) return <div>Loading...</div>;
  if (!data) return <div>존재하지 않는 게시글입니다.</div>;

  return (
    <>
      <Header />
      <BlogDetail data={data} handleGoList={handleGoList} />
      <Footer />
    </>
  );
}
